import React from 'react'
// Todo: Lazy load + destructing props is not yet supported, but this needs to be refactored to import only the icon prop passed to the component.
import * as RemixIcons from 'react-icons/ri'

const Icon = ({ name, ...props }) => {
  const IconTag = typeof name === 'string' ? RemixIcons[name] : <></>

  return <IconTag {...props} />
}

export default Icon
